import Dashboard from '../components/app-dashboard';

export default Dashboard.Applications
